module.exports = __webpack_public_path__ + "static/media/mockup3.60c470e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/mockup3.png
// module id = 895
// module chunks = 0